import { render, staticRenderFns } from "./CurrentUser.vue?vue&type=template&id=f8ff524e&scoped=true"
import script from "./CurrentUser.vue?vue&type=script&lang=js"
export * from "./CurrentUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ff524e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8ff524e')) {
      api.createRecord('f8ff524e', component.options)
    } else {
      api.reload('f8ff524e', component.options)
    }
    module.hot.accept("./CurrentUser.vue?vue&type=template&id=f8ff524e&scoped=true", function () {
      api.rerender('f8ff524e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation/CurrentUser.vue"
export default component.exports